import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TourManagementService {

  constructor() { }

  getMockDate(): Observable<ITourData> {
    
    return of({ 
        groupDetails: [
          { 
            groupName: 'Today',
            details: [
              {
                tourId: 1,
                title: 'Tour 1',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              }
            ]
          },
          { 
            groupName: 'This Week',
            details: [
              {
                tourId: 2,
                title: 'Tour 2',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              },
              {
                tourId: 3,
                title: 'Tour 3',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              }
            ]
          },
          { 
            groupName: 'This Month',
            details: [
              {
                tourId: 4,
                title: 'Tour 4',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              },
              {
                tourId: 5,
                title: 'Tour 5',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              },
              {
                tourId: 6,
                title: 'Tour 6',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              }
            ]
          },
          { 
            groupName: 'Upcoming',
            details: [
              {
                tourId: 7,
                title: 'Tour',
                startDate: new Date().toLocaleString(),
                endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString()
              }
            ]
          }
        ]
    });
  }

  getDetailsMockDate(): Observable<ITourDetail> {
    return of({ 
      tourId: 1,
      title: 'Tour 1',
      startDate: new Date().toLocaleString(),
      endDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleString(),
      city: 'Los Angeles',
      state: 'CA',
      postalCode: '90001',
      country: 'US'
    });
  }
}

/**
 * 
 */
 export interface ITourData {
  groupDetails: ITourGroupDetail[];
}

/**
 * 
 */
export interface ITourGroupDetail {
  groupName: string;
  details: ITourDetail[];
}

/**
 * 
 */
 export interface ITourDetail {
  tourId: number;
  title: string;
  startDate: string;
  endDate: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  bookingAgentId?: number;
  bookingAgentCode?: string;
  customerId?: number;
  customerCode?: string;
  passengerId?: number;
  passengerCode?: string;
  eventId?: number;
  eventCode?: string;
  billingInformation?: string;
  tourManagementInformation?: string;
  sinage?: string; // name sign to read
  vehicleId?: number;
  vehicleCode?: string;
  vehicleName?: string;
  notes?: string;
}
